<template>
  <img
    class="object-cover"
    src="@/assets/images/emojis/emoji-girls.png"
  >
</template>